const default_duration = 5000

const state = {}

const mutations = {}

let counter = 0

const actions = {
    toastInfo({ dispatch }, payload) {
        dispatch('toast', Object.assign({ type: 'info' }, payload))
    },

    toastSuccess({ dispatch }, payload) {
        dispatch('toast', Object.assign({ type: 'success' }, payload))
    },

    toastWarning({ dispatch }, payload) {
        dispatch('toast', Object.assign({ type: 'warning' }, payload))
    },

    toastDanger({ dispatch }, payload) {
        dispatch('toast', Object.assign({ type: 'danger' }, payload))
    },

    toast(vuex, payload) {
        let vNodesMsg
        const id = `toast-${counter++}`
        if (payload?.button?.to && payload?.button?.label && payload?.button?.$router) {
            const h = this._vm.$createElement
            vNodesMsg = h('div', { class: ['mb-0'] }, [
                payload.text,
                h(
                    'button',
                    {
                        class: `btn btn-xs btn-block btn-${payload.type || 'info'} mt-2`,
                        on: {
                            click: () => {
                                payload.button.$router.push(payload.button.to)
                                this._vm.$bvToast.hide(id)
                            },
                        },
                    },
                    [payload.button.label]
                ),
            ])
        }
        this._vm.$bvToast.toast(vNodesMsg ? [vNodesMsg] : payload.text || '', {
            id: id,
            autoHideDelay: payload.duration || default_duration,
            variant: payload.type || 'info',
            title: payload.title || payload,
            solid: true,
            to: payload.to,
        })
        counter++
    },
}

const getters = {}

export default {
    state,
    mutations,
    actions,
    getters,
}
